import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const FreeTier = () => {
  const navigate = useNavigate();
  const [secondsLeft, setSecondsLeft] = useState(5);
  
  useEffect(() => {
    // Set a timer to auto-continue after 5 seconds
    const timer = setInterval(() => {
      setSecondsLeft(prev => {
        if (prev <= 1) {
          navigate('/');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      // Clean up the timer when component unmounts
      clearInterval(timer);
    };
  }, [navigate]);

  const handleContinue = () => {
    navigate('/');
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4">
      <div className="w-full max-w-4xl content-container rounded-lg shadow-md p-8 mb-8">
        <h2 className="text-2xl font-semibold text-center mb-6">Free Tier</h2>
        
        <p className="text-center text-gray-600 mb-8">
          Thank you for using our free service.
          <br />
          <span className="text-sm">You will be automatically redirected in {secondsLeft} seconds.</span>
        </p>
        
        {/* Placeholder for advertisement */}
        <div className="min-h-[400px] flex items-center justify-center bg-gray-100 rounded mb-8">
          <p className="text-gray-500">Advertisement Pending</p>
        </div>
        
        <div className="text-center">
          <button
            onClick={handleContinue}
            className="px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
          >
            Continue to App
          </button>
        </div>
      </div>
    </div>
  );
};

export default FreeTier;
